import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ServiceDetail from './components/ServiceDetail';
import { servicesData } from './data/servicesData';

export default function ServicePage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const service = servicesData.find((s) => s.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!service) {
      navigate('/');
    }
  }, [slug, service, navigate]);

  useEffect(() => {
    if (!service) return;
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const pageUrl = `${siteUrl}/services/${service.slug}`;
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          '@id': `${pageUrl}/#service`,
          name: service.title,
          description: service.shortDesc,
          url: pageUrl,
          provider: {
            '@type': 'Organization',
            name: '株式会社永恒',
            url: siteUrl,
            telephone: '090-6002-2788',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '二俣2-14-18',
              addressLocality: '市川市',
              addressRegion: '千葉県',
              addressCountry: 'JP',
            },
          },
          areaServed: {
            '@type': 'Country',
            name: 'JP',
          },
        },
        {
          '@type': 'WebPage',
          '@id': `${pageUrl}/#webpage`,
          url: pageUrl,
          name: `${service.title} | 株式会社永恒`,
          description: service.shortDesc,
          inLanguage: 'ja',
          isPartOf: { '@id': `${siteUrl}/#website` },
        },
        {
          '@type': 'FAQPage',
          '@id': `${pageUrl}/#faq`,
          mainEntity: service.faq.map((item) => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.a,
            },
          })),
        },
      ],
    };

    const existingScript = document.getElementById('schema-service');
    if (existingScript) existingScript.remove();
    const script = document.createElement('script');
    script.id = 'schema-service';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    // Update page title and meta description
    document.title = `${service.title} | 株式会社永恒 — 内装仕上工事 千葉・東京`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', service.shortDesc);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', pageUrl);

    return () => {
      const s = document.getElementById('schema-service');
      if (s) s.remove();
    };
  }, [service]);

  if (!service) return null;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServiceDetail service={service} />
      <Footer />
    </div>
  );
}
